import Loading from 'components/Loading';
import settingServiceSelectors from 'features/settingService/services/selectors';
import { LoadingPageStyled } from 'services/UI/LoadingPage';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import CategoryPart from './CategoryPart';
import ServicePart from './ServicePart';
import useSettingService from './useSettingService';
import { useMemo } from 'react';
type Props = {
  v2?: boolean;
};
const ServiceSettingV2 = ({ v2 }: Props) => {
  const categories = shopSelectors.data.categories();
  const activeCateId = settingServiceSelectors.serviceTab.activeCate();
  const loading = shopSelectors.loading.categories();
  const settingService = useSettingService();

  const activeCate = useMemo(() => {
    return categories.find(o => o.id === activeCateId) || null;
  }, [activeCateId, categories]);

  const handleDeleteServices = settingService.deleteServices;
  const handleApplySupplyFee = settingService.applySupplyFee;
  const handleEditNameCate = settingService.editNameCate;
  const handleEditNameService = settingService.editNameService;
  const handleUpdateInfoService = settingService.updateInfoServices;
  const handleDeleteCategory = settingService.deleteCategory;
  const handlePreOrderServices = settingService.preOrderServices;
  const handleAddCategory = settingService.addCategory;
  const handleAddMoreServiceForCate = settingService.addMoreServiceForCate;
  const handleApplyDiscountItemsCate = settingService.applyDiscountItemsCategory;


  if (loading && categories.length <= 1) return (
    <Container className={v2 ? 'v2' : ''}><Loading /></Container>
  );

  return (
    <>
      <Container className={v2 ? 'v2' : ''}>
        <CategoryPart
          v2={v2}
          onEditNameCate={handleEditNameCate}
          data={categories}
          activeCate={activeCate}
          onChooseCate={settingService.setActiveCate}
          onAddCategory={handleAddCategory}
          onDeleteCategory={handleDeleteCategory}
        />
        <ServicePart
          data={activeCate}
          onDeleteServices={handleDeleteServices}
          onApplySupplyFee={handleApplySupplyFee}
          onEditNameCate={handleEditNameCate}
          onEditNameService={handleEditNameService}
          onUpdateInfoService={handleUpdateInfoService}
          onDeleteCategory={handleDeleteCategory}
          onPreOrderServices={handlePreOrderServices}
          onAddMoreServiceForCate={handleAddMoreServiceForCate}
          onApplyDiscountItemsCate={handleApplyDiscountItemsCate}
        />
      </Container>
      {loading && <LoadingPageStyled>
        <div className="box"><Loading /></div>
      </LoadingPageStyled>}
    </>
  );
};

export default ServiceSettingV2;

const Container = styled.div`
  display: flex;
  justify-content: center;
  background: #E5E5E5;
  height: calc(100% - 30px);
  gap: 24px;
  padding: 24px 0 0 24px;
  &.v2 {
    background-color: #F5F5F5;
    padding: 0;
    height: calc(100% - 8px);
    padding-top: 8px;
  }
`;
